import _implicitStylesheets from "./overviewHighlights.css";
import _implicitScopedStylesheets from "./overviewHighlights.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-6" class="highlights-label${0}"${2}>${"t1"}</h3>`;
const $fragment2 = parseFragment`<li class="highlight-card${0}" data-testid="highlight-card"${2}><span class="highlight-number${0}" aria-hidden="true"${2}>${"t2"}</span><p type-style="body-2" class="highlight-text${0}"${2}>${"t4"}</p></li>`;
const stc0 = {
  classMap: {
    "highlights-grid": true
  },
  attrs: {
    "data-testid": "highlights-grid"
  },
  key: 2
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, i: api_iterator, h: api_element} = $api;
  return [$cmp.hasLabel ? api_static_fragment($fragment1, 1, [api_static_part(1, null, api_dynamic_text($cmp.highlightsLabel))]) : null, api_element("ul", stc0, api_iterator($cmp.numberedHighlights, function (highlight) {
    return api_static_fragment($fragment2, api_key(4, highlight.key), [api_static_part(2, null, api_dynamic_text(highlight.number)), api_static_part(4, null, api_dynamic_text(highlight.text))]);
  }))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1siq6gesq0c";
tmpl.legacyStylesheetToken = "undefined-_overviewHighlights";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
